import { CONFIG } from "../i18n";

const Footer = ({ t }) => (
  <footer className="site-footer" data-testid="site-footer">
    <span data-testid="footer-copy">© 2026 Cindy Silva</span>
    <span className="footer-tag serif-i">{t.footer}</span>
    <span className="footer-contact mono">
      <a href={`mailto:${CONFIG.email}`} data-testid="footer-email-link">{CONFIG.email}</a>
      <i className="diamond" aria-hidden="true" />
      <a href={`tel:+${CONFIG.whatsapp}`} data-testid="footer-phone-link">+1 (239) 231-5323</a>
    </span>
    <a className="footer-privacy" href="/guia-como-crear-una-pagina-web" data-testid="footer-guia-link">{t.footerGuia}</a>
    <a className="footer-privacy" href="/limpieza" data-testid="footer-limpieza-link">{t.footerLimpieza}</a>
    <a className="footer-privacy" href="/privacidad" data-testid="footer-privacy-link">{t.footerPrivacy}</a>
  </footer>
);

export default Footer;
